import React from 'react';
import './PartnerIntegrationSection.scss';

const CTAHREF = 'https://geuer-geuer-art.de/'

export default function PartnerIntegrationSection({
    title,
    text,
    ctaLabel,
    imageSrc,
    imageAlt = ''
}) {
  return (
    <section className="partner-integration">
      <div className="inner">
        <div className="partner-integration__layout">
          <div className="partner-integration__media">
            <img src={imageSrc} alt={imageAlt} className="partner-integration__image" />
          </div>
          <div className="partner-integration__content">
            <h2 className="partner-integration__title">{title}</h2>
            <p className="partner-integration__text">{text}</p>
            <a
              href={CTAHREF}
              target="_blank"
              rel="noreferrer"
              className="btn landing-cta-4 partner-integration__cta"
              aria-label={ctaLabel}
            >
              <span className="text">{ctaLabel}</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
